<template>
  <navbar class="container-fluid fixed-top bg-light">
      <a class="navbar-brand" href="#">Endless Games</a>
  </navbar>
</template>

<script>
export default {
  name: 'TopFixedNavbar',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/global/TopFixedNavbar.vue